<template>
    <PickBackground type="vas" type2="production-order"/>
</template>

<script>
import PickBackground from '@/views/pick/Background.vue';

export default {
    components:{
        PickBackground
    },
}
</script>